import React, {
  createContext,
  useCallback,
  useState,
  useContext,
  ReactNode,
  Dispatch,
  SetStateAction,
  useRef,
} from "react";

import { useDisclosure, UseDisclosureProps } from "@chakra-ui/react";

import api from "../services/api";

interface User {
  nomeCompleto: string;
  primeiroAcesso: boolean;
  cadastroId: number;
  documento: string;
  habilitaCartaoPrograma: boolean;
  codigo?: string;
  perfil?: string;
}

interface DataUser {
  possuiAceiteRegulamento?: boolean;
  aceitaContatoTelefonico?: boolean;
  aceitaEmail?: boolean;
  aceitaSMS?: boolean;
  aceitaWhatsApp?: boolean;
  parceiroEmail?: boolean;
  parceiroSms?: boolean;
  parceiroWhatsApp?: boolean;
  confirmarSenha?: string;
  senha?: string;
  ativo?: boolean;
  celular?: string;
  dataNascimento?: Date | undefined;
  documento?: string;
  editouAniversario?: boolean;
  email?: string;
  genero?: string;
  id?: number;
  nome?: string;
  sobrenome?: string;
  imagem?: string;
  codigoFacebook?: string;
  codigo?: string;
  endereco?: {
    cep?: string;
    endereco?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    estado?: string;
  };

  cadastroEnderecos?: {
    id?: number;
    endereco?: string;
    numero?: string;
    complemento?: string;
    bairro?: string;
    cidade?: string;
    estado?: string;
    cep?: string;
  }[];
}

interface AuthState {
  token: string;
  user: User;
}

interface SignInCredentials {
  login: string;
  senha: string;
}

interface SignInCredentialsFacebook {
  codigoFacebook: string;
  emailFacebook: string;
  origem: string;
}

interface AuthContextProps {
  user: User;
  dataUser: DataUser;
  isLogged: boolean;
  signIn(credentials: SignInCredentials): Promise<any>;
  signOut(): void;
  updateUser(user: DataUser): Promise<DataUser>;
  setDataUser: Dispatch<SetStateAction<DataUser>>;
  useDisclosure(): UseDisclosureProps;
  signInFacebook(credentials: SignInCredentialsFacebook): Promise<any>;
}

const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);

type AuthProdiverProps = {
  children: ReactNode;
};

const AuthProvider = ({ children }: AuthProdiverProps) => {
  const userRef = useRef({} as User);
  const tokenRef = useRef("");
  const [isLogged, setIsLogged] = useState((): boolean => {
    let token = localStorage.getItem('@FPontos:token')
    if (token) return true;
    return false;
  });

  const token = localStorage.getItem("@FPontos:Admintoken") ?? localStorage.getItem("@FPontos:token") ?? "";
  const dataStorage = localStorage.getItem("@FPontos:user");

  const [dataUser, setDataUser] = useState<DataUser>((): any => {
    const dataUserLocal = localStorage.getItem("@FPontos:dataUser");
    const routeName = window.location?.href;

    if (routeName.split('/home?')[1]) {
      const routeName = window.location?.href;
      let url: any = routeName.split('/home?')[1]
      url = decodeURIComponent('/home?' + url)
      const urlParams = new URLSearchParams(url);
      const tokenAdmin = urlParams.get('token');
      if (tokenAdmin) {
        api.defaults.headers.common["Authorization"] = `Bearer ${tokenAdmin}`;
        let nomeCompleto = url.split('nomeCompleto=')[1];
        nomeCompleto = nomeCompleto.split('&')[0];
        nomeCompleto = nomeCompleto.split('+').join(' ');
        const data = {
          "nomeCompleto": nomeCompleto,
          "primeiroAcesso": JSON.parse(urlParams.get('primeiroAcesso') ?? ""),
          "cadastroId": Number(urlParams.get('cadastroId')),
          "habilitaCartaoPrograma": JSON.parse(urlParams.get('habilitaCartaoPrograma') ?? ""),
          "possuiCartaoPrograma": JSON.parse(urlParams.get('possuiCartaoPrograma') ?? ""),
          "promotora": JSON.parse(urlParams.get('promotora') ?? ""),
          "codigo": JSON.parse(urlParams.get('codigo') ?? ""),
          "perfil": JSON.parse(urlParams.get('perfil') ?? "0"),
        }

        localStorage.setItem("@FPontos:Admintoken", tokenAdmin);
        localStorage.setItem("@FPontos:dataUser", JSON.stringify(data));
        localStorage.setItem("@FPontos:user", JSON.stringify(data));
        return
      }
    } else if (token && dataStorage) {

      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      return ""
    }
  });

  const [data, setData] = useState<AuthState>(() => {
    if (token && dataStorage) {
      //api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      return { token, user: JSON.parse(dataStorage) };
    }

    return {} as AuthState;
  });

  const signIn = useCallback(async ({ login, senha }) => {
    let perfil = '0';
    if (senha.indexOf(';') === 1) {
      perfil = senha[0];
      senha = senha.substring(2);
    }
    const response = await api.post("/autenticacao/autenticar", {
      login,
      senha,
      origem: process.env.REACT_APP_ORIGEM  || 'site'
    });

    const { nomeCompleto, token, primeiroAcesso, cadastroId, documento, validado, celular, possuiCelular, habilitaCartaoPrograma, possuiCartaoPrograma, promotora, codigo } = response.data;
    const user = { nomeCompleto, primeiroAcesso, cadastroId, documento, habilitaCartaoPrograma, possuiCartaoPrograma, promotora, codigo, perfil };
    userRef.current = user;
    tokenRef.current = token;
    if (!validado) {
      const validateDataUser = {
        cadastroId: cadastroId,
        celular: celular,
        possuiCelular: possuiCelular
      };
      return validateDataUser
    } else {
      setData({ token: tokenRef.current, user: userRef.current });
      localStorage.setItem("@FPontos:token", token);
      localStorage.setItem("@FPontos:user", JSON.stringify(user));
    }
    setIsLogged(true)

    return true
  }, []);

  const signInFacebook = useCallback(async ({ codigoFacebook, emailFacebook, origem }) => {
    const response = await api.post("/autenticacao/autenticar", {
      codigoFacebook,
      emailFacebook,
      origem
    });

    const { nomeCompleto, token, primeiroAcesso, cadastroId, documento, validado, celular, possuiCelular, habilitaCartaoPrograma, possuiCartaoPrograma, promotora, codigo } = response.data;
    const user = { nomeCompleto, primeiroAcesso, cadastroId, documento, habilitaCartaoPrograma, possuiCartaoPrograma, promotora, codigo };
    userRef.current = user;
    tokenRef.current = token;
    if (!validado) {
      const validateDataUser = {
        cadastroId: cadastroId,
        celular: celular,
        possuiCelular: possuiCelular
      };
      return validateDataUser
    } else {
      setData({ token: tokenRef.current, user: userRef.current });
      localStorage.setItem("@FPontos:token", token);
      localStorage.setItem("@FPontos:user", JSON.stringify(user));
      setIsLogged(true)
    }

    return true
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem("@FPontos:token");
    localStorage.removeItem("@FPontos:user");
    localStorage.removeItem("@FPontos:dataUser");
    localStorage.clear();
    setData({} as AuthState);
    setDataUser({} as DataUser);
    setIsLogged(false)
  }, []);

  const updateUser = useCallback(
    async (dataUser: DataUser): Promise<any> => {
      try {
        await api.put("/cadastro", dataUser);
        localStorage.setItem("@FPontos:dataUser", JSON.stringify(dataUser));
        setDataUser(dataUser);
      } catch (error) {
        console.log(error);
      }
    },
    [setDataUser]
  );

  return (
    <AuthContext.Provider
      value={{
        user: data.user,
        dataUser,
        isLogged,
        signIn,
        signOut,
        updateUser,
        setDataUser,
        useDisclosure,
        signInFacebook,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth(): AuthContextProps {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
}

export { AuthProvider, useAuth };